export default () => (
  [
    {
      kind: "block",
      contents: `<p>${ i18n.t('text') }</p>`,
      css_background: "transparent",
      css_background_image: "none",
      css_background_repeat: "repeat",
      css_background_position: "center center",
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "10",
      css_padding_right: "10",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "image",
      alt: "",
      src: "",
      href: "",
      width: "",
      height: "",
      natural_width: "0",
      natural_height: "0",
      text_align: "left",
      normal_size: false,
      mobile_autosize: false,
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "0",
      css_padding_right: "0",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "button",
      label: i18n.t('button'),
      href: "",
      height: "9",
      font_family: "",
      font_size: "16px",
      text_align: "center",
      css_color: "",
      css_border_color: "",
      css_size: "",
      css_background: "#2ba6cb",
      css_background_image: "none",
      css_background_repeat: "repeat",
      css_background_position: "center center",
      css_border_radius: "0",
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "0",
      css_padding_right: "0",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "spacer",
      height: "20",
      css_background: "transparent",
      css_background_image: "none",
      css_background_repeat: "repeat",
      css_background_position: "center center",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "social",
      text_align: "center",
      size: "32",
      socials: [
        { srv: "tenchat", url: "" },
        { srv: "telegram", url: "" },
        { srv: "youtube", url: "" }
      ],
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "0",
      css_padding_right: "0",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "divider",
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "0",
      css_padding_right: "0",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "table",
      rows: [
        {
          columns: [
            { width: "50", items: [] },
            { width: "50", items: [] }
          ]
        }
      ],
      css_background: "transparent",
      css_background_image: "none",
      css_background_repeat: "repeat",
      css_background_position: "center center",
      meta: { kind: "table" },
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "video",
      alt: "",
      src: "",
      href: "",
      width: "",
      height: "",
      natural_width: "0",
      natural_height: "0",
      text_align: "left",
      normal_size: false,
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "0",
      css_padding_right: "0",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "map",
      alt: "",
      href: "",
      src: "",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    },
    {
      kind: "html",
      contents: "<div>HTML code</div>",
      css_background: "transparent",
      css_background_image: "none",
      css_background_repeat: "repeat",
      css_background_position: "center center",
      css_padding_top: "0",
      css_padding_bottom: "0",
      css_padding_left: "10",
      css_padding_right: "10",
      show: "",
      visibility_conditions_group_logical: "",
      visibility_conditions: []
    }
  ]
);
